import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type EditButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "testId" | "buttonType" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
    buttonType?: "submit" | "button";
    variant?: ComponentProps<typeof BaseActionButton>["variant"];
};

const EditButton = ({
    label = "Edit",
    loadingText = "Editing...",
    buttonType = "button",
    variant = "outline",
    ...props
}: EditButtonProps) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText}
            iconType="edit"
            testId="edit-button"
            buttonType={buttonType}
            variant={variant}
            {...props}
        />
    );
};

export default EditButton;
